"use client";

import React from "react";
import MobileTipModal from "@/components/MobileTipModal";
import { isMobile } from "@/utils/is";

export interface DeviceContextProps {
  isMobile?: boolean;
}

const DeviceContext = React.createContext<DeviceContextProps>({});

function DeviceProvider({ children }: { children: React.ReactNode }) {
  return (
    <DeviceContext.Provider value={{ isMobile: isMobile() }}>
      {children}
      <MobileTipModal />
    </DeviceContext.Provider>
  );
}

export { DeviceContext, DeviceProvider };
